<template>
  <div>
    <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/news.png" :width="'100%'" />
    <div class="news-list">

      <!-- <div class="title">{{ $t('News') }}</div> -->
      <template v-if="newsList.length > 0">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="item in newsList" :key="item.id">
            <NewsCard :newsDetail="item" />
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <el-empty :description="$t('common.noData')"></el-empty>
      </template>
    </div>
  </div>
</template>
<script>
import NewsCard from '@/components/NewsCard'
import { getArticleList } from '@/api'
export default {
  data() {
    return {
      newsList: []
    }
  },
  components: {
    NewsCard
  },
  mounted() {
    getArticleList().then(res => {
      this.newsList = res.data.data
    })
  }
}
</script>
<style lang="stylus" scoped>
.news-list
  width 100%
  padding-left: 15px
  padding-right: 15px
  padding-bottom: 60px
  max-width 1366px
  margin 0 auto
  overflow hidden
  .title
    font-size 16px
    font-weight bold
    color $color-black-65
    margin: 30px 0 30px 0
</style>
